import { useGlobalDrawer } from "@/core/context/GlobalDrawerProvider"
import { useIsMobile } from "@utils/hook/screenSizeHooks"

export function useBrainSearchWidth() {
  const isMobile = useIsMobile()
  const drawer = useGlobalDrawer("brainSearch")
  const isSidePanel = Boolean(drawer.params.drawerAsk)
  return {
    isMobile,
    isSidePanel,
    isWide: !isMobile && !isSidePanel,
  }
}
